module.exports = __webpack_public_path__ + "static/media/gerb-1.5a9bd03e.png";